import store from '@/store'
import { getMainMetadata, buildDescription } from '@/components/combined-predict/models/metadata'
import { joinWithBr } from '@/utils/html'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'

const getEpiSuiteMetadata = () => {
  const keys = get(modelStateRegistry, 'epiSuite.keys')
  return store.getters[`epiSuite/${keys.getMetadata}`] || null
}

const getEpiSuiteMainMetadata = () => {
  const metadata = getEpiSuiteMetadata()
  const mainMetadata = metadata?.info
  const name = mainMetadata?.title
  const description = mainMetadata?.description
  const version = mainMetadata?.version
  return getMainMetadata({ name, description, version })
}

const getEpiSuiteDescription = () => {
  const mainMetadata = getEpiSuiteMainMetadata()
  return buildDescription(mainMetadata)
}

const getEpiSuiteResultProperties = () => {
  const metadata = getEpiSuiteMetadata()
  return metadata?.components?.schemas?.EpiSuiteResults?.properties || null
}

const getEpiSuiteModelDescription = (modelId) => {
  const modelMeta = getEpiSuiteResultProperties()?.[modelId]
  if (!modelMeta?.description) {
    if (modelMeta?.allOf?.length) {
      const allOfWithoutGeneric = [...modelMeta.allOf].filter(
        (subMeta) =>
          typeof subMeta.description === 'string' && !subMeta.description.startsWith('Generic module results'),
      )
      return joinWithBr(
        allOfWithoutGeneric.map((subMeta) => {
          return subMeta.description?.endsWith('.') ? subMeta.description : `${subMeta.description}.`
        }),
      )
    }
  }

  return modelMeta?.description ?? null
}

export { getEpiSuiteModelDescription, getEpiSuiteDescription }
